module.exports = __webpack_public_path__ + "img/Heart Icon - charcoal.dcb28c40.svg";